export default __webpack_public_path__ + "static/media/arrow-left.d7cfacd2.svg";